(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentAccessInfoDeleteController', AgentAccessInfoDeleteController);

    AgentAccessInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'AgentAccessInfo'];

    function AgentAccessInfoDeleteController($uibModalInstance, entity, AgentAccessInfo) {
        var vm = this;

        vm.agentAccessInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            AgentAccessInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
